import * as Factory from 'factory.ts'
import faker from 'faker'

import { CurrencyConstructorFactory } from '@webapp/core/entities/external/Currency/Currency.factory'
import { EntityFactory } from '@webapp/core/utils/mocks/EntityFactory'
import { MileageRatePresetUnits } from '@webapp/modules/expense/entities/enums'
import {
  MileageRatePreset,
  type MileageRatePresetConstructor,
} from './MileageRatePreset'

export const MileageRatePresetConstructorFactory =
  Factory.Sync.makeFactory<MileageRatePresetConstructor>({
    id: Factory.each(() => faker.random.number()),
    name: Factory.each(() => faker.random.word()),
    rate: Factory.each(() => Number.parseFloat(faker.commerce.price())),
    currency: Factory.each(() => CurrencyConstructorFactory.build()),
    unit: MileageRatePresetUnits.MILES,
    advisoryFuelRate: null,
    tax: null,
  })

export const MileageRatePresetFactory = EntityFactory(
  MileageRatePreset,
  MileageRatePresetConstructorFactory
)
